/* eslint-disable complexity */
/* eslint-disable no-restricted-imports */
/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMMultiAddToCartPayload } from '@/data/types/GTM';
import { findProductAttribute } from 'integration/utils/findProductAttribute';
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';
import { getAvailableProductSizes } from 'integration/utils/getAvailableProductSizes';
import { mergeRibbonsForProduct } from '@/utils/mergeRibbonsForProduct';
import { extractPartNumberFather } from '@/data/utils/extractPartNumberFather';

// eslint-disable-next-line complexity
export const getGTMMultiAddToCartEventData = async (payload: GTMMultiAddToCartPayload) => {
	const { availability, products, from_look, look_id, look_name } = payload;

	const items = products.map((product) => {
		const { name, partNumber, productPrice } = product ?? {};
		const currency = productPrice?.currency ?? '';
		const value = productPrice?.offer;
		const list = productPrice?.list;

		const brand = findProductAttribute(product?.attributes ?? [], 'Marca')?.value;
		const size = getValueByPathFromUnknown(product.attributes, ['Talla']);
		const gender = findProductAttribute(product?.attributes ?? [], 'Genero')?.value;
		const family = findProductAttribute(product?.attributes ?? [], 'Familia')?.value;
		const use = findProductAttribute(product?.attributes ?? [], 'Uso')?.value;
		const sizes = getAvailableProductSizes(product, availability);
		const ribbons = mergeRibbonsForProduct(product?.ribbons ?? []).flatMap(
			(ribbon) => ribbon.value
		);
		const availableQuantity = availability?.length ? Number(availability[0].availableQuantity) : 0;
		const lowStock = availableQuantity > 0 && availableQuantity < 15 ? 'Si' : 'No';
		const priceType = (value ?? 0) > 0 && value !== (list ?? 0) ? 'Oferta' : 'Full price';
		const color = findProductAttribute(product?.attributes ?? [], 'Color1')?.value;

		return {
			type: product?.type,
			partNumber,
			item_id: partNumber,
			item_group_id: extractPartNumberFather(partNumber),
			item_name: name,
			item_brand: product.manufacturer,
			quantity: 1,
			currency,
			price: Number(productPrice?.offer),
			keyword: product?.keyword,
			affiliation: 'Dportenis',
			productPrice,
			brand,
			size,
			gender,
			family,
			use,
			sizes,
			ribbons,
			lowStock,
			priceType,
			color,
		};
	});

	return { items, from_look, look_id, look_name };
};
